// extracted by mini-css-extract-plugin
module.exports = {"container":"editable-title_container__32xFR","input":"editable-title_input__TqO1G"};